import { render, staticRenderFns } from "./class_student.vue?vue&type=template&id=6277f80e&scoped=true"
import script from "./class_student.vue?vue&type=script&lang=js"
export * from "./class_student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6277f80e",
  null
  
)

export default component.exports